import React, { useState } from 'react'
import MyTextField from '../../../UI/form/MyTextField'
import TextFieldUniversal from '../../../validate/form/text/TextFieldUniversal'

const LoginFormPassword = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')

  return (
    // <MyTextField 
    //     label={'Пароль'}
    //     placeholder={'Вкажіть свій пароль'}
		// type='password'
    // />
    <TextFieldUniversal
		type='password'
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Пароль'} 
        placeholder={'Вкажіть свій пароль'}
        validates={{
            isEmpty: true
        }}
        // forciblyValue={forciblyValue}
        required={true}
    />
  )
}

export default LoginFormPassword